import { queryGroup } from 'liyu-pc-base/api/org/group';
import { useUserStore } from 'liyu-pc-base/init-plugin';

export default () => {
  const userStore = useUserStore();
  const org = userStore.currentOrg;

  const search_config: any = {
    model: {
      org_id: org?.id,
      aim_org_id: org?.id,
      is_active: true,
      pageSize: 1000,
    },
    watch: [],
  };
  return {
    getData: queryGroup,
    searchConfig: search_config,
  };
};
